module.exports = __webpack_public_path__ + "img/nav-abw.44530bc9.svg";